import React from 'react';

import PropTypes from 'prop-types';
import { css } from 'styled-components';

import { Checkbox } from '@techstyle/react-components';

import { useSizeInputContext } from './SizeInput';

const customInputStyle = css`
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 50%;
  border: 1px solid ${({ theme }) => theme.colors.lavender250};
  font-size: 16px;
  height: 62px;
  line-height: 19px;
  margin: 0;
  width: 62px;
`;

const customInputCheckedStyle = css`
  background-color: ${({ theme }) => theme.colors.active};
  border: 1px solid ${({ theme }) => theme.colors.lavender250};
`;

const customInputFocusStyle = css`
  box-shadow: 0 0 0 1px ${({ theme }) => theme.colors.white},
    0 0 0 1px ${({ theme }) => theme.colors.active};
`;

const OneSizeCheckboxes = ({
  inputStyle = customInputStyle,
  inputCheckedStyle = customInputCheckedStyle,
  inputFocusStyle = customInputFocusStyle,
  name: checkboxName,
  ...rest
}) => {
  const { options, onChange, value } = useSizeInputContext();

  return options.map(item => (
    <label key={`${checkboxName}-${item}`}>
      <Checkbox
        data-autotag={`one-size-check-box-${checkboxName}-${item}`}
        inputStyle={inputStyle}
        checkmarkIcon={<>{item}</>}
        inputCheckedStyle={inputCheckedStyle}
        inputFocusStyle={inputFocusStyle}
        name={checkboxName}
        onChange={onChange}
        value={item}
        checked={item === value}
        {...rest}
      />
    </label>
  ));
};

OneSizeCheckboxes.propTypes = {
  checkmarkCheckedStyle: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  checkmarkCheckingStyle: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  checkmarkDisabledStyle: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  checkmarkFocusStyle: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  checkmarkIcon: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.node,
  ]),
  checkmarkStyle: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  checkmarkUncheckingStyle: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  className: PropTypes.string,
  inputCheckedStyle: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  inputCheckingStyle: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  inputDisabledStyle: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  inputFocusStyle: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  inputStyle: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  inputUncheckingStyle: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  name: PropTypes.string,
  rootClassName: PropTypes.string,
  rootStyle: PropTypes.object,
  style: PropTypes.object,
  tabIndex: PropTypes.number,
};

export default OneSizeCheckboxes;
